import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import {
  CreateNotificationUnsubscribeDocument,
  DeleteNotificationUnsubscribeDocument,
  NotificationChannel,
  NotificationEventType,
  NotificationUnsubscribe,
  NotificationUnsubscribesDocument,
} from 'src/graphql/generated/graphql';
import { getTableConfig } from './config';
import { useMutation } from '@apollo/client';

type NotificationPreferencesTableProps = Omit<TableProps, 'columns'> & {
  data: NotificationEventType[];
  channels: NotificationChannel[];
  unsubscribes: Partial<NotificationUnsubscribe>[];
};

export const NotificationPreferencesTable = ({
  data,
  channels,
  unsubscribes,
  ...props
}: NotificationPreferencesTableProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'notification.preferences.list',
  });

  const [createNotificationUbsubscribe] = useMutation(
    CreateNotificationUnsubscribeDocument,
    { refetchQueries: [NotificationUnsubscribesDocument] },
  );

  const [deleteNotificationUbsubscribe] = useMutation(
    DeleteNotificationUnsubscribeDocument,
    { refetchQueries: [NotificationUnsubscribesDocument] },
  );

  const onUnsubscribeChange = async (
    create: boolean,
    eventTypeId: string,
    channelId: string,
  ) => {
    const variables = {
      data: {
        eventTypeId,
        channelId,
      },
    };

    if (create) {
      await createNotificationUbsubscribe({ variables });
    } else {
      await deleteNotificationUbsubscribe({ variables });
    }
  };

  const tableConfig = getTableConfig(data, {
    t,
    channels,
    unsubscribes,
    onUnsubscribeChange,
  });

  return <Table {...props} data={data} columns={tableConfig} />;
};
